// @flow
export default {
  ad_edit: {
    image_cropper: {
      make_crop: 'Вы можете выбрать область картинки, которая будет показана в объявлении',
      ok: 'Готово',
      cancel: 'Отмена'
    },
    url: 'Ссылка',
    auto_utms: 'UTM-метки будут добавлены автоматически',
    more_info: 'Подробнее',
    our_utms: 'Используются ваши UTM-метки',
    title: 'Заголовок',
    description: 'Описание',
    domain: 'Домен',
    form_has_errors: 'Форма заполнена с ошибками',
    previews: 'Предпросмотр объявления',
    preview_options: {
      all: 'Все',
      column: 'В колонке',
      lenta: 'Лента',
      other: 'Другое',
      google: 'Google',
      target_mail: 'myTarget',
      vk: 'VK',
      facebook: 'Facebook',
      instagram: 'Instagram',
      stories: 'Stories'
    },
    add_replica: 'Добавить копию объявления',
    replica: '%{index}-ое объявление',
    common_header: 'Общее',
    vk_header: 'ВКонтакте',
    target_mail_header: 'myTarget',
    facebook_header: 'Facebook',
    google_header: 'Google',
    logo_header: 'Логотип',
    logo_loader_text:
      'Загрузка логотипа: по умолчанию мы используем логотип-заглушку, но вы можете ',
    based_on_template:
      'Прикреплено к шаблону. Рекоммендуется редактировать шаблон вместо объявления, иначе следующее редактирование шаблона перезапишет текущие изменения',
    edit_template: 'Редактировать шаблон',
    snippet_header: 'Сниппет в ВКонтакте',
    snippet_loader_text: 'Загрузка сниппета: '
  },
  ads_list: {
    fix: 'Исправить',
    edit: 'Редактировать',
    minimize: 'Свернуть',
    load_new_image: 'Требуется загрузить изображение',
    impressions: 'Показы',
    clicks: 'Клики',
    ctr: 'CTR',
    spent: 'Потрачено',
    cpc: 'Ср. CPC',
    goal_price: 'Цена цели',
    goal_percentage: '% целей'
  },
  image_validations: {
    required_not_empty: 'не может быть пустым',
    wrong_size: 'размеры изображения не удовлетворяют требованиям всех провайдеров'
  },
  budget_select: {
    currency: '₽',
    cant_be_empty: 'не может быть пустым',
    minimum_value: 'минимум %{value} ₽',
    maximum_value: 'максимум %{value} ₽',
    recommended_budget: 'Рекомендуемый бюджет: 15 000 ₽/мес.',
    recommended_daily_budget: 'Рекомендуемый бюджет: 1 500 ₽/день',
    recommended_budget_hint:
      'На тесты одной аудитории (целевой группы) в одной рекламной сети  рекомендуется выделять 3-5 тыс рублей. Такой тестовый бюджет позволит вам понять эффективность выбранной ЦА (Целевой Аудитории) для вашего бизнеса и выделить эффективные объявления для заданной ЦА'
  },
  statistics: {
    advertisement: 'Реклама',
    all: 'Все',
    apply: 'Применить фильтры',
    audiences: 'Аудитории',
    campaigns: 'Кампании',
    common: 'Общие',
    export_xlsx: 'Экспорт в XLSX формате',
    facebook: 'Facebook и Instagram',
    fb: 'Facebook',
    filters_are_modified:
      'Фильтры были изменены. Нажмите "%{button}" для загрузки актуальных данных',
    google: 'Google',
    group_by: 'Группировать по',
    loading: 'Загрузка...',
    metric: 'Web-аналитика',
    period: 'Период',
    providers: 'Каналы трафика',
    senler: 'Сенлер',
    smm: 'SMM',
    statistic_fields: 'Столбцы',
    target_mail: 'myTarget (Одноклассники и проекты Mail.ru)',
    total: 'Всего',
    unsubscribed_percentage: '% отписок',
    vk: 'Вконтакте',
    group_by_value: {
      day: 'дням',
      week: 'неделям',
      month: 'месяцам',
      quarter: 'кварталам',
      year: 'годам',
      campaigns: 'кампаниям',
      audiences: 'аудиториям',
      advertisements: 'объявлениям'
    }
  },
  payment_type_select: {
    auto_description:
      'Алгоритмы OneRetarget будут выбирать оптимальное соотношение между стоимостью клика и охватом заданной целевой аудитории'
  },
  targeting_sources: {
    contact_list: 'Список контактов',
    lookalike_segment: 'Похожий сегмент, созданный из сегмента по посетителям сайтов',
    lookalike_contact: 'Похожий сегмент, созданный из списка контактов',
    remove_from_list: 'Удалить "%{name}" из списка',
    choose_from_created: 'Выбрать из созданных',
    choose_sources: 'Выбор сегментов',
    choose_sources_hint:
      'Укажите, по каким сегментам показывать рекламу. Для этого выберите включающие (кому показывать рекламу) и исключающие (кому не показывать) сегменты.',
    segments_subtitle: 'Сегменты ретаргетинга с сайта',
    contacts_subtitle: 'Сегменты из загруженных контактов',
    lookalikes_subtitle: 'Похожие сегменты',
    excluded: 'Исключить',
    included: 'Включить',
    new_lookalike: 'Создать похожий сегмент',
    new_contact_list: 'Загрузить контакты',
    new_segment: 'Сегмент по посетителям сайта',
    ready: 'Готово',
    ignored: 'Не учитывать',
    coverage: 'Размер',
    create_segment: 'Создать новый сегмент',
    name: 'Название',
    kind: 'Тип',
    domain: 'Домен',
    import_success: 'Успешно импортировано',
    nothing_to_import: 'Все сегменты уже импортированы',
    provider_targeting_source: 'Сегмент, импортированный из провайдера',
    import_targeting_sources: {
      vk: 'Загрузить из ВКонтакте',
      target_mail: 'Загрузить из myTarget',
      facebook: 'Загрузить из Facebook'
    },
    provider_targeting_sources_subtitle: 'Сегменты, импортированные из провайдеров'
  },
  campaigns_table: {
    advertisements_count:
      '%{smart_count} объявление |||| %{smart_count} объявления |||| %{smart_count} объявлений',
    audiences_count:
      '%{smart_count} Аудитория |||| %{smart_count} Аудитории |||| %{smart_count} Аудиторий',
    archivate: 'Перенести в архив',
    create_new_audience: 'Создать новую аудиторию',
    create_audience: 'Создать аудиторию',
    rejected_count: 'Количество объявлений, не прошедших модерацию',
    copy: 'Копировать',
    create_new: 'Создать новое',
    create_advertisement: 'Создать объявление',
    code_to_be_set: 'Код для установки',
    counter_code_comment:
      'Для сбора аудитории и запуска ретаргетинга вам нужно установить на все страницы сайтов наш javascript код. Код нужно разместить сразу после открывающего тега <body>',
    settings: 'Настройки',
    advertisements_list: 'Список объявлений',
    statistics: 'Статистика',
    rename_campaign: 'Переименовать',
    rename_campaign_btn: 'Обновить',
    rename_campaign_form_header: 'Переименовать',
    rename_campaign_name_label: 'Название',
    rename_campaign_errors_occured: 'Произошли ошибки при сохранении',
    multi: 'Мультиформат',
    column: 'В колонке',
    promo: 'Пост в ленте',
    product: 'Товарный фид',
    promotion: 'Продвижение постов',
    with_video: 'Видеореклама',
    leadform: 'Лид-форма',
    payment_popup: {
      save_btn: 'Сохранить',
      cancel_btn: 'Отменить',
      cpc: 'За клик',
      cpm: 'За 1000 показов',
      cpa: 'За действие',
      auto: 'Авто',
      cpc_cell: 'CPC',
      cpm_cell: 'CPM',
      cpa_cell: 'CPA',
      auto_cell: 'Авто'
    },
    budget_popup: {
      budget_cycle_day_cell: '₽/д',
      budget_cycle_month_cell: '₽/м',
      save_btn: 'Сохранить',
      cancel_btn: 'Отменить',
      budget_cycle_day: 'в день',
      budget_cycle_month: 'в месяц'
    },
    statistic_filter: {
      all: 'Все',
      apply: 'Применить',
      less: 'меньше',
      more: 'больше',
      equal: 'равно'
    }
  },
  age_range: {
    from: 'от',
    to: 'до',
    label: 'Возраст',
    hint: 'От %{min_age} до %{max_age}',
    description:
      'Укажите возраст вашей целевой аудитории. Допустимые значения от %{min_age} до %{max_age} лет (требование рекламных сетей)'
  },
  locations_select: {
    more_cities: 'Еще города',
    search_hint: 'Введите название города или страны',
    no_results: 'Ничего не найдено',
    searching: 'Идёт поиск...'
  },
  replenishment: {
    replenish: 'Пополнить',
    amount_with_commission: 'Сумма оплаты с комиссией составит',
    no_commission: 'Вся сумма будет зачислена без комиссии',
    recommendations: {
      header: 'Рекомендуемая сумма пополнения',
      month: '— На месяц:',
      week: '— На неделю:',
      replenish: 'Пополнить',
      currency: '₽'
    },
    robo_replenish: 'Робокасса',
    bank_replenish: 'Банковский перевод (для юр. лиц)',
    replenish_balance: 'Пополнить',
    min_amount_robokassa:
      'Робокасса - платежный агрегатор, позволяющий пополнить баланс Банковской картой, Webmoney, Яндекс.Деньгами, Qiwi и другими способами. Минимальная сумма пополнения через Робокассу составляет %{amount} рублей',
    min_amount_bank:
      'Минимальная сумма пополнения безналичным платежем составляет %{amount} рублей',
    commission_comment: 'Сумма пополнения будет увеличена на комиссию системы - %{commission}%',
    processing: 'Идёт обработка... Подождите несколько секунд',
    success: 'Успех',
    errors: 'Возникли ошибки'
  },
  provider_statuses: {
    button_edit_advertisement: 'Редактировать объявление',
    turned_off_label: 'Выключено',
    turned_off_description: 'Для запуска объявления используйте тумблер слева',
    paused_label: 'Нет денег',
    paused_description:
      'Недостаточно денег на балансе. Пополните баланс, чтобы реклама запустилась',
    inactive_label: 'Аудитория выключена',
    inactive_description: 'Сначала необходимо запустить аудиторию',
    complete_label: 'Аудитория завершена',
    no_budget_reason:
      'На сегодня мы не смогли выделить бюджет на этот рекламный канал. Как правило, эта ситуация возникает, когда на вашем балансе недостаточно денег.',
    about_link: 'Узнать подробнее',
    no_info: 'Нет дополнительной информации',
    suspended_note: 'Для запуска сети используйте иконку слева',
    unconnected_note:
      'Для запуска рекламы Вам необходимо предоставить доступ к своему рекламному кабинету',
    button_connect_account: 'Подключить аккаунт',
    segments: 'Сегменты',
    contacts: 'Контакт-листы',
    lookalike_segments: 'Похожие сегменты',
    lookalike_contacts: 'Похожие контакт-листы'
  },
  automated_rules_table: {
    header: {
      name: 'Название',
      providers: 'Сети',
      audiences: 'Аудитории',
      conditions: 'При каком условии?',
      action: 'Что делать?',
      conditions_action: 'Условие и действие',
      frequency: 'Частота',
      options: 'Управление'
    },
    new: 'Создать новое',
    are_you_sure: 'Удалить правило "%{name}"?',
    apply: 'Создать',
    delete: 'Удалить',
    edit: 'Редактировать',
    update: 'Обновить',
    update_rule: 'Редактирование правила #%{id}',
    create_rule: 'Новое правило',
    rule: 'Автоматическое правило',
    add_condition: 'Добавить условие',
    unknown_condition: 'Неизвестное условие',
    impressions: 'Показы',
    clicks: 'Клики',
    goals: 'Цели',
    conversions: 'Конверсии',
    average_cpc: 'CPC',
    average_cpm: 'CPM',
    ctr: 'CTR',
    budget: 'Бюджет',
    spent: 'Расход',
    goal_price: 'Стоимость цели',
    conversion_price: 'Стоимость конверсии',
    less: 'меньше',
    more: 'больше',
    stop: 'Остановить объявление',
    start: 'Запустить объявление',
    select_audiences: 'Выберите аудитории',
    select_providers: 'Выберите площадки',
    select_action: 'Выберите действие',
    period_prefix: 'за',
    total: 'всё время',
    today: 'сегодня',
    last_days: 'вчера |||| последние %{smart_count} дня |||| последние %{smart_count} дней',
    amount_prefix: 'на',
    edge_amount_prefix: 'не более/менее, чем',
    sum: '₽',
    percent: '%',
    stop_audience: 'Остановить аудиторию',
    start_audience: 'Включить аудиторию',
    stop_advertisement: 'Остановить объявление',
    increase_price: 'Увеличить ставку',
    decrease_price: 'Уменьшить ставку',
    increase_budget: 'Увеличить бюджет',
    decrease_budget: 'Уменьшить бюджет',
    select_check_frequency: 'Выберите частоту проверки условий',
    select_apply_frequency: 'Выберите частоту действия',
    once_per_hour: 'Раз в час',
    once_per_two_hours: 'Раз в 2 часа',
    once_per_three_hours: 'Раз в 3 часа',
    once_per_four_hours: 'Раз в 4 часа',
    once_per_day: 'Раз в день',
    once_per_week: 'Раз в неделю',
    once_per_two_weeks: 'Раз в две недели',
    check_frequency: 'Проверка условий: ',
    apply_frequency: 'Действие: ',
    rule_name_placeholder: 'Stop if CPA > 500p',
    checked_at: 'Проверено: ',
    applied_at: 'Применено: ',
    audience_warning_message:
      'Автоправила можно применять к аудиториям, в которых выбрана только одна рекламная сеть',
    logs: 'Посмотреть логи',
    conditions: 'Условия:',
    action: 'Действие:',
    no_audiences: 'Нет аудиторий'
  },
  automated_rules_logs_table: {
    header: {
      rule: 'Правило',
      owner: 'Аудитория/Объявление',
      logged_at: 'Время',
      message: 'Сообщение'
    },
    audience: 'Аудитория',
    advertisement: 'Объявление',
    back: 'Список правил',
    owner: '%{type} № %{id}'
  },
  interests: {
    label: 'Интересы',
    select_interests: 'Выбрать интересы',
    search: 'Поиск групп интересов',
    ok: 'Готово',
    open_modal: 'Выбрать интересы',
    select_all: 'Выбрать все найденные',
    clear_all: 'Сбросить все найденные',
    vk_provider: 'ВКонтакте',
    google_provider: 'Google',
    target_mail_provider: 'myTarget',
    facebook_provider: 'Facebook',
    fb_ad_interests_loading_error_msg:
      'Произошла ошибка во время загрузки дополнительных Facebook интересов',
    additional_interests: 'Доп. опции',
    additional_interests_found: 'Доп. опции (найденные)'
  },
  demographics: {
    label: 'Соц-дем',
    open_modal: 'Выбрать соц-дем',
    select_demographics: 'Выбрать соц-дем',
    search: 'Поиск по соц-демам',
    ok: 'Готово',
    vk_provider: 'ВКонтакте',
    google_provider: 'Google',
    target_mail_provider: 'myTarget',
    facebook_provider: 'Facebook',
    select_all: 'Выбрать все найденные',
    clear_all: 'Сбросить все найденные'
  },
  provider: {
    modal: {
      ok_btn: 'Готово'
    }
  },
  gender_select: {
    label: 'Пол'
  },
  provider_translations: {
    facebook: 'Facebook',
    google: 'Google',
    target_mail: 'myTarget',
    vk: 'ВКонтакте',
    yandex: 'Яндекс',
    metrica: 'Метрика',
    google_analytics: 'Google Analytics'
  },
  provider_short_translations: {
    facebook: 'FB',
    google: 'Google',
    target_mail: 'MT',
    vk: 'VK',
    yandex: 'Я',
    metrica: 'Метрика',
    google_analytics: 'GA'
  },
  statuses: {
    active: 'активно',
    moderation: 'на модерации',
    rejected: 'отклонено',
    unknown: 'неизвестно',
    paused: 'остановлено',
    pending_review: 'ожидает подтверждения',
    deleted: 'в архиве',
    archived: 'заархивировано',
    audience_paused: 'нет денег',
    campaign_group_paused: 'кампания остановленна',
    preapproved: 'предварительно одобрено',
    disapproved: 'отклонено',
    no_budget: 'бюджет не выделен',
    complete: 'завершено',
    inactive: 'выключено',
    suspended: 'сеть отключена',
    unconnected: 'не подключено',
    error: 'ошибка'
  },
  advertisement_table_thead: {
    clicks: 'Клики',
    goal_percentage: '% целей',
    campaign_audience: 'Кампания/Аудитория',
    cpc: 'eCPC',
    cpm: 'eCPM',
    ctr: 'CTR',
    goals: 'Цели',
    goal_price: 'Цена цели',
    impressions: 'Показы',
    moderation: 'Модерация',
    picture: 'Картинка',
    spent: 'Потрачено, ₽',
    title_and_desc: 'Заголовок и текст',
    advertisement: 'Объявление'
  },
  advertisement_table_filter_form: {
    statistics: 'Статистика',
    accept_btn: 'Применить',
    isChanged: 'Фильтры были изменены. Нажмите "Применить" для загрузки данных',
    isLoading: 'Загрузка...',
    divided: 'Статистика в разрезе по сетям',
    overall: 'Статистика по всем сетям',
    google: 'Статистика по Google',
    target_mail: 'Статистика по myTarget',
    vk: 'Статистика по ВКонтакте',
    facebook: 'Статистика по Facebook ',
    yandex: 'Статистика по Яндекс',
    create_advertisement: 'Создать объявление',
    period: 'за период',
    template_options_placeholder: 'Выберите шаблоны'
  },
  advertisement_table_tfoot: {
    total: 'Итого'
  },
  audience_edit: {
    select_parameters: 'Укажите параметры целевой аудитории',
    form_has_errors: 'Форма заполнена с ошибками',
    placement_type_label: 'Формат показа объявлений',
    providers_label: 'Выбор сетей и плейсментов',
    invalid_advertisements: 'Есть ошибки в объявлениях',
    vk_placement_label: 'Плейсменты ВКонтакте',
    empty_vk_placement: 'Выберите плейсмент',
    cpm: 'За 1000 показов',
    cpc: 'За клик',
    copy_success: 'Аудитория успешно скопирована',
    both: 'Все',
    all: 'Все',
    mobile: 'Мобайл',
    desktop: 'Десктоп',
    female: 'Ж',
    male: 'М',
    promo_post: 'Пост в ленте',
    multi_format: 'Мультиформат',
    with_video: 'Видеореклама',
    column: 'В колонке',
    only_travellers: 'ВКонтакте: только путешествен- ники', // '-' is used, because the translation doesn't fit the tag width
    payment_type_label: 'Оплата',
    advertisement_widget: {
      select_advertisements: 'Выберите объявления для копирования'
    },
    price_recommendations: {
      no_data: 'Нет данных по охвату аудитории',
      provider: 'Сеть',
      users: 'Аудитория',
      effective_title: {
        cpm: 'CPM рекоменд',
        cpc: 'CPC рекоменд',
        cpa: 'CPA рекоменд'
      },
      min_title: {
        cpm: 'CPM мин',
        cpc: 'CPC мин',
        cpa: 'CPA мин'
      },
      effective_desc: {
        cpm: 'Рекомендуемая стоимость за 1000 показов',
        cpc: 'Рекомендуемая стоимость клика',
        cpa: 'Рекомендуемая стоимость действия'
      },
      min_desc: {
        cpm: 'Минимальная стоимость за 1000 показов',
        cpc: 'Минимальная стоимость клика',
        cpa: 'Минимальная стоимость действия'
      },
      auto_price: 'Ср. стоимость клика',
      google: 'Google',
      target_mail: 'myTarget',
      target_mail_not_provided_label: 'Не предоставляет',
      target_mail_not_provided_text:
        'Для ретаргетинга и микролокаций myTarget не предоставляет размер доступной аудитории',
      vk: 'VK',
      facebook: 'Facebook',
      retargeting_wrapper: {
        retargeting_description:
          'Ретаргетинг возвращает от 5 до 10% аудитории. Планируйте ваш бюджет с учетом этой статистики',
        best_budget_for_retargeting: 'Оптимальный бюджет ретаргетинга',
        in_help_center: 'в Справке'
      }
    },
    footer: {
      advertisements_has_error: 'необходимо исправить объявления',
      and_go_to_create_advertisements: 'и перейти к созданию объявлений',
      create: 'Создать аудиторию',
      update: 'Обновить аудиторию',
      copy: 'Копировать аудиторию'
    },
    about_company: {
      more: 'как заполнить',
      hint:
        "Согласно ст. 8 Федерального Закона «О рекламе» необходимо соблюдать следующее требование: В рекламе товаров при дистанционном способе их продажи должны быть указаны сведения о продавце таких товаров: наименование, место нахождения и государственный регистрационный номер записи о создании юридического лица; фамилия, имя, отчество, основной государственный регистрационный номер записи о государственной регистрации физического лица в качестве индивидуального предпринимателя. \n Например: ООО 'Моя Компания'  123456, г. Соликамск, ул. Мейловская, д.39, стр.79, ОГРН 1234432112344321"
    },
    common_attributes: {
      audience_status_label: 'Статус',
      budget_label: 'Установите бюджет и принцип оплаты',
      campaign_label: 'Назовите аудиторию',
      campaign_creation_label: 'и выберите кампанию'
    },
    finish_date: {
      empty: 'без ограничения по длительности',
      clear: 'Сбросить'
    },
    improve_advertisements: {
      hint:
        'Разрешить OneRetarget добавлять новые или корректировать созданные объявления, а так же параметры таргетинга, для улучшения результатов рекламы и прохождения модерации'
    },
    campaign: {
      placeholder: 'Новая кампания'
    },
    showtime: {
      date_day_short: {
        monday: 'Пн',
        tuesday: 'Вт',
        wednesday: 'Ср',
        thursday: 'Чт',
        friday: 'Пт',
        saturday: 'Сб',
        sunday: 'Вс'
      },
      translations: {
        everytime: 'Круглосуточно',
        workdays: 'Будни',
        worktime: 'Рабочее время',
        holidays: 'Выходные',
        custom_timetable: 'Свое расписание',
        percents_in_week: '% времени в неделю',
        change: 'Изменить',
        edit_timetable: 'Выберите часы показа рекламы',
        finish_edit: 'Готово'
      }
    },
    conversion: {
      label: 'Конверсия',
      set_conversion: 'Укажите конверсию',
      create_conversion_link: 'создайте',
      modal_header: 'Создать конверсию',
      modal_create_btn: 'Создать конверсию',
      modal_name_field_placeholder: 'Название конверсии',
      modal_domain_name_field_placeholder: 'Домен',
      modal_url_masks_field_placeholder: 'URL маски',
      modal_url_masks_instructions:
        'Укажите вхождения в URL, при посещении которых посетитель будет записываться в аудиторию. Каждое вхождение с новой строки',
      modal_url_masks_example_description: 'Например, вы можете указать:',
      conversion_id_placeholder: 'Выберите конверсию',
      window_placeholder: 'Выберите окно конверсии',
      url_masks_of_conversion: 'Маски конверсии %{conversionName}',
      window_conversion_label: 'Окно конверсии',
      or: 'или',
      no_results: 'Ничего не найдено'
    },
    targeting: {
      segments_and_contacts_comment:
        'Также вы можете задать сегменты, каким пользователям показывать рекламу, а каким не показывать. Вы можете создать новые сегменты, или использовать ранее созданные.',
      excluded_groups: {
        excluded_groups: 'Исключить сообщества ВКонтакте',
        excluded_groups_hint:
          'Вы можете исключить из показа рекламы участников выбранных сообществ ВКонтакте. Чтобы исключить сообщества - начните вводить их название. Данный параметр будет учитываться только для рекламных систем ВКонтакте и MyTarget, а для других систем он будет проигнорирован'
      },
      vk_user_devices: {
        label: 'Устройства в ВКонтакте',
        placeholder: 'Выберите устройства'
      }
    },
    retargeting: {
      add_retargeting_rules: 'Выбрать сегмент',
      sources_hint:
        'Сегменты позволяют показывать рекламу по посетителям вашего сайта, по пользователям из загруженного списка контактов (емейлов, телефонов, ВКонтакте USER_ID), а так же по "Похожим сегментам".'
    },
    micro_location: {
      gmap: {
        help1:
          'С помощью возможностей локальной рекламы вы можете показывать рекламу людям, которые находятся в непосредственной близости от вашего бизнеса.',
        help2:
          'Для запуска рекламы вам нужно отметить на карте точки и задать для них радиус (радиус можно указывать от 1 до 10 километров). Или вы можете указать сразу несколько точек',
        help_link: 'загрузив файл с координатами'
      }
    },
    public_fields: {
      vk_publics: 'Группа ВКонтакте',
      vk_placeholder: 'Ваши группы во Вконтакте',
      fb_publics: 'Страница Facebook',
      fb_placeholder: 'Ваши страницы в Facebook',
      provider_not_connected_partner: 'Сеть не привязана',
      provider_not_connected_ort: 'Нет доступных',
      connect_provider_partner: 'привязать',
      connect_provider_ort: 'добавить'
    },
    loadable_select: {
      reload_btn: 'Перезагрузить',
      loading: 'Загрузка ...',
      failed: 'Не удалось загрузить',
      no_results: 'Ничего не найдено',
      no_found_publics: 'Не найдены записи',
      refresh_token: 'Ошибка токена',
      refresh_token_message:
        'Для загрузки страниц требуется обновить доступ. Для этого пройдите по ',
      refresh_token_link_text: 'ссылке'
    },
    price_input: {
      label: 'Цена',
      gt_value_msg: 'Значение должно быть не меньше',
      rare_showing_msg: 'Слишком низкая ставка, ваша реклама будет редко показываться',
      not_in_all_providers_showed_msg: 'Реклама может показываться не во всех сетях',
      price_alert_msg: 'Не для всех выбранных сетей возможно установить указанную цену.',
      price_alert_warning:
        'Для сетей, где это невозможно, цена будет повышена до минимально допустимой. ',
      price_alert_link: 'Подробнее'
    },
    age_limit: {
      no_results: 'Ничего не найдено'
    },
    additional_params: 'Дополнительно',
    legal_information: 'Юридическая информация'
  },
  shared_ad_accounts: {
    message: 'Список доступа к аккаунтам был изменен'
  },
  single_media_loader: {
    loading: 'Загрузка...',
    less_than_mb: 'до %{size} мегабайт',
    size_restrictions: 'от %{minWidth}x%{minHeight} до %{maxWidth}x%{maxHeight}',
    choose: 'выберите файл ...',
    choose_another: 'Заменить',
    files_loaded: 'Загружено файлов: %{count}'
  },
  provider_publics: {
    title: 'Страницы',
    vk_publics: {
      title: 'Ваши VK группы',
      has_access: 'Есть доступ',
      no_access: 'Нет доступа',
      request_access: 'Выдать',
      check_access: 'Проверить',
      access: 'доступ',
      refresh_list: 'Загрузить список моих групп',
      refresh_token: 'Переполучить токен',
      no_publics: 'Страницы (группы) еще не добавлены: ',
      refresh_button: 'добавить'
    },
    facebook_publics: {
      title: 'Ваши Facebook страницы',
      has_access: 'Есть доступ',
      request_access: 'Выдать доступ',
      check_access: 'Проверить доступ',
      refresh_list: 'Загрузить список страниц',
      refresh_token: 'Переполучить токен',
      no_publics: 'Страницы (группы) еще не добавлены: ',
      refresh_button: 'добавить'
    },
    thead: {
      label: 'Название',
      ads_access: 'Доступ'
    },
    public_link: {
      facebook_instructions:
        'Чтобы добавить группы ФБ вам нужно выдать нам роль "Рекламодатель" для работы с группой. Вначале нажмите кнопку "Отправить запрос на доступ", после этого в настройках сообщества ФБ администратору сообщества нужно будет одобрить запрос на доступ для OneRetarget',
      vk_instructions:
        'Для добавления группы ВКонтакте в список доступных вам нужно для нашего технического аккаунта <a href="https://vk.com/one.retarget" target="_blank">https://vk.com/one.retarget</a> выдать роль "Администратор" или "Рекламодатель" в сообществах ВК, от лица которых вы будете запускать рекламу.',
      ajax_error: 'Произошла ошибка при запросе',
      btn_text: 'Ок, понятно'
    }
  },
  geograhpy: {
    label: 'География',
    cities: 'Города и регионы',
    micro: 'Выбрать на карте'
  },
  providers_balance: {
    update: 'Обновить балансы',
    vk: 'ВКонтакте',
    facebook: 'Facebook',
    target_mail: 'myTarget',
    RUB: '%{balance} ₽',
    USD: '$ %{balance}',
    update_failed: 'Ошибка при обновлении балансов',
    no_balance: 'N/A'
  },
  lookalike_form: {
    name_placeholder: 'Название',
    create_lookalike: 'Создать похожий сегмент',
    empty_country: 'Выберите страну',
    empty_origin: 'Выберите сегмент',
    empty_level: 'Выберите уровень точности',
    '1': '1 - Выше точность, меньше охват',
    '5': '5 - Баланс между точностью и охватом',
    '10': '10 - Выше охват, ниже точность'
  },
  provider_previews: {
    /* TODO: avoid duplication between translations */
    facebook: {
      APPLY_NOW: 'Подать заявку',
      CONTACT_US: 'Свяжитесь с нами',
      DOWNLOAD: 'Скачать',
      INSTALL_MOBILE_APP: 'Установить приложение',
      LEARN_MORE: 'Узнать больше',
      SHOP_NOW: 'В магазин',
      SIGN_UP: 'Регистрация',
      WATCH_MORE: 'Подробнее'
    },
    target_mail: {
      apply: 'Подать заявку',
      begin: 'Начать',
      book: 'Забронировать',
      buy: 'Купить',
      buy_ticket: 'Купить билет',
      call: 'Позвонить',
      choose: 'Выбрать',
      create: 'Создать',
      download: 'Загрузить',
      enroll: 'Записаться',
      get: 'Получить',
      learn: 'Узнать',
      learnMore: 'Подробнее',
      listen: 'Слушать',
      open: 'Открыть',
      order: 'Заказать',
      playGame: 'Играть',
      register: 'Зарегистрироваться',
      see_menu: 'Меню',
      signUp: 'Вступить',
      to_shop: 'В магазин',
      try: 'Попробовать',
      visitSite: 'Перейти',
      watch: 'Смотреть'
    },
    vk: {
      app_game_join: 'Играть',
      app_join: 'Запустить',
      auto: 'Автовыбор',
      begin: 'Начать',
      book: 'Забронировать',
      buy: 'Купить',
      buy_ticket: 'Купить билет',
      call: 'Позвонить',
      choose: 'Выбрать',
      contact: 'Связаться',
      create: 'Создать',
      enroll: 'Записаться',
      fill: 'Заполнить',
      get: 'Получить',
      im2: 'Написать',
      im: 'Связаться',
      im_group2: 'Написать',
      im_group: 'Связаться',
      install: 'Установить',
      join: 'Вступить',
      join_event: 'Я пойду',
      join_group: 'Вступить',
      join_public: 'Подписаться',
      learn: 'Узнать',
      listen: 'Слушать',
      more: 'Подробнее',
      open: 'Открыть',
      open_url: 'Перейти',
      order: 'Заказать',
      register: 'Зарегистрироваться',
      to_shop: 'В магазин',
      try: 'Попробовать'
    }
  },
  statistic_metrics_page: {
    apply: 'Применить',
    choose_counter: 'Выберите счётчик',
    choose_counters: 'Выберите счётчики',
    choose_goals: 'Выберите цели',
    counter: 'Счётчик',
    empty_message: 'Для провайдера нет счётчиков',
    goal_id: 'ID цели',
    goal_name: 'Название цели',
    goals_placeholder: 'Все',
    google_analytics: 'Google Analytics',
    integrate: 'Подключить',
    metrica: 'Яндекс.Метрика',
    no_counters_message: 'Нет счётчиков',
    no_goals_message: 'Нет целей',
    refresh_token: 'Переполучить токен',
    update: 'Обновить список счётчиков'
  },
  table_headers: {
    active_cps: 'CPS активн.',
    active_subscribed: 'Активные подписки',
    advertisements: 'Объявления',
    age: 'Возраст',
    average_cpc: 'eCPC',
    average_cpm: 'eCPM',
    budget: 'Бюджет/сеть',
    campaign: 'Кампания',
    clicks: 'Клики',
    conversion_percentage: '% конверсий',
    conversion_price: 'Цена конверсии',
    conversion_rate_ranking: 'Коэффициент конверсий',
    conversions: 'Конверсии',
    counter_impressions: 'Визиты',
    cpc_effective: 'Рекомендуемый CPC',
    cpm_effective: 'Рекомендуемый CPM',
    cps: 'CPS, руб',
    ctr: 'CTR, %',
    drr: 'DRR, %',
    demographics: 'СоцДем',
    engagement_rate_ranking: 'Коэффициент вовлечённости',
    fb_placements: 'Плейсменты ФБ',
    goal_percentage: '% целей',
    goal_price: 'Цена цели',
    goals: 'Цели',
    group_joins: 'Вступления',
    group_joins_percentage: '% вступлений',
    group_joins_price: 'Цена вступления',
    group_visits: 'Переходы в группу',
    impressions: 'Показы',
    interests: 'Интересы',
    leads: 'Лиды',
    lead_percentage: '% лидов',
    lead_price: 'Цена лида',
    likes: 'Лайки',
    locations: 'Гео',
    payment: 'Ставка',
    period: 'Даты',
    placement_type: 'Формат',
    platform: 'Площадка',
    providers_list: 'Провайдеры',
    quality_ranking: 'Качество',
    reached_users: 'Охват',
    sex: 'Пол',
    spent: 'Потрачено',
    status: 'Статус',
    subscribed: 'Число подписок',
    total_limit: 'Общий лимит',
    total_revenue: 'Общая прибыль',
    transactions: 'Количество транзакций',
    transaction_price: 'Цена транзакции',
    unsubscribed: 'Число отписок',
    unsubscribed_percentage: '% отписок',
    users: 'Размер',
    vk_placement: 'Плейсменты ВК'
  },
  vk_placement_option: {
    promopost_without_button: 'Универсальная запись',
    promopost_with_button: 'Промопост с кнопкой',
    promopost_without_public: 'Реклама сайта',
    promopost_with_big_image: 'Универсальная запись (произвольная картинка)'
  }
}
